import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { MCPConfigSnippet } from '../../../../src/components/Product/MCP/MCPConfig';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ol>
      <li parentName="ol">{`Open `}<a parentName="li" {...{
          "href": "https://windsurf.com/"
        }}>{`Windsurf`}</a>{` and navigate to `}<strong parentName="li">{`Windsurf Settings > Cascade > MCP Servers`}</strong></li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Manage MCP Servers`}</strong></li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`View raw config`}</strong></li>
      <li parentName="ol">{`Update `}<inlineCode parentName="li">{`mcp_config.json`}</inlineCode>{` with the following configuration:`}</li>
    </ol>
    <MCPConfigSnippet variant="windsurf" mdxType="MCPConfigSnippet" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      